<template>
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :placeholder="placeholder"
    :value="value"
    :multiple="multiple"
    taggable
    clearable
    label="label"
    :reduce="(option) => option.value"
    :create-option="createOption"
    @input="(state) => $emit('input', state || null)"
  />
</template>
<script>
export default {
  name: 'LocationStateSelect',
  props: {
    value: [String, Array],
    multiple: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'location-state-select',
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    placeholder: {
      type: String,
      default: 'All',
    },
  },
  data() {
    return {
      options: [],
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(state) {
        this.ensureOption(state);
      },
    },
  },
  mounted() {
    this.getStateOptions();
  },
  methods: {
    formatOptionLabel({ code, name }) {
      return name ? `${code} - ${name}` : code;
    },
    createOption(input) {
      return { label: input, value: input };
    },
    ensureOption(state) {
      [].concat(state || []).forEach((value) => {
        if (value && !this.options.some((option) => option.value === value)) {
          this.options.push(this.createOption(value));
        }
      });
    },
    getStateOptions() {
      this.$locationsAPI.getStateOptions().then((response) => {
        this.options = response.data.state_options.map((option) => ({
          label: this.formatOptionLabel(option),
          value: option.code,
        }));
        this.ensureOption(this.value);
      });
    },
  },
};
</script>
